import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = (opened) =>
  makeStyles(() =>
    createStyles({
      header: {
        zIndex: 10,
      },
      descriptionContainer: {
        maxHeight: opened ? 500 : 0,
        overflow: 'hidden',
        transition: 'all 1s',
      },
    }),
  );

export default useStyles;
